
import { Logo } from "@/components/display";
import { Box, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { ReactNode, useMemo } from "react";

interface PrintContainerHeaderProps {
    title?: ReactNode,
    criteria?: string[],
    description?: string,
    additionalDisplay?: { label: ReactNode, value: ReactNode }[]
}

export default function PrintContainerHeader({
    title = "Reporte",
    criteria = [],
    description,
    additionalDisplay
}: PrintContainerHeaderProps) {
    const dateString = useMemo(() => {
        return dayjs().format("DD/MM/YYYY");
    }, [])

    const renderCriteria = criteria.filter(s => Boolean(s));

    return <Stack gap={3}>
        <Stack gap={1}>
            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"start"}>
                <Logo />
                <Typography fontSize={"0.75rem"}>
                    <Box component={"span"} fontWeight={"bold"}>Generado en:</Box> {dateString}
                </Typography>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} justifyContent={"center"}>
                <Typography variant="h6" component={"h1"} >{title}</Typography>
            </Stack>
        </Stack>

        {description && <Typography> {description} </Typography>}

        {renderCriteria.length > 0 && <Box>
            <Box component={"span"} fontWeight={"bold"}>Criterios:</Box>
            <Box component={"ul"}>
                {renderCriteria.map(s => <Box key={s} component={"li"}>{s}</Box>)}
            </Box>
        </Box>}

        {additionalDisplay && additionalDisplay.map(({ label, value }, i) => <Stack key={i} direction={"row"} gap={3}>
            <Typography variant="subtitle1" fontWeight={"bold"}>{label}: </Typography>
            <Typography variant="body1">{value}</Typography>
        </Stack>)}
    </Stack>
}